import { QuotesSummary } from 'quoting/quotes-summary/quotes-summary';
import { ProvideQuoteListState } from 'shared/contexts/quotes-summary-context';
import { Redirect } from 'react-router-dom';
import { PERMISSIONS } from 'shared/constants';
import { useTitle } from 'shared/hooks';
import { useUserPermissions } from 'shared/hooks/use-user-permissions';
import { ROUTES } from './routes';

export function QuotesSummaryResolver() {
  const userPermissions = useUserPermissions();

  useTitle('Quoting - American Bath');

  if (!userPermissions.includes(PERMISSIONS['quoting.view'])) {
    return <Redirect to={ROUTES.unauthorized} />;
  }
  return (
    <ProvideQuoteListState>
      <QuotesSummary />
    </ProvideQuoteListState>
  );
}
